export default __webpack_public_path__ + "b85b16eeaa8cd6e2b556901d57e4206f.png";